/**
 * DD Operational Tour
 *
 * Walkthrough for the operational Due Diligence view (building-specific).
 * Shows users how to view and update DD question answers.
 */

import { TourDefinition } from '../config/tourSteps';

export const ddOperationalTour: TourDefinition = {
  id: 'ddOperationalTour',
  steps: [
    {
      element: '[data-tour="dd-status-overview"]',
      popover: {
        title: 'Status Overzicht',
        description:
          'Zie in één oogopslag de status van alle DD-categorieën voor dit gebouw. Groen = volledig beantwoord, oranje = gedeeltelijk beantwoord, rood = onbeantwoord.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-category-section"]',
      popover: {
        title: 'Categorie Vragen',
        description:
          'Elke categorie toont alle vragen die beantwoord moeten worden. Vragen met gekoppelde bestandslabels worden automatisch ingevuld door de AI wanneer relevante documenten worden geüpload.',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-answer-field"]',
      popover: {
        title: 'Antwoorden Bewerken',
        description:
          'Klik op een antwoordveld om het handmatig te bewerken. AI-gegenereerde antwoorden kunnen worden aangepast of aangevuld met extra informatie.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: '[data-tour="dd-document-link"]',
      popover: {
        title: 'Gekoppelde Documenten',
        description:
          'Bekijk welke documenten zijn gebruikt om dit antwoord te genereren. Klik om direct naar het brondocument te gaan voor verificatie.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
